export default __webpack_public_path__ + "static/media/our-partner-logo-10.de2035d1.jpeg";